/*global _ */
import Main, {
  axios,
  setPromise,
  getEndpoint,
  omitId
} from './main'

export {
  APIURI,
  client_secret,
  client_id,
  getFirstErrorMessage,
  getErrorMessage,
  getErrorMessages,
  getErrorMessagesWithKeys,
  endpoints,
  services,
  handlePromise,
  promise,
  setPromise,
  getEndpoint,
} from './main'

export const read = async (payload, options = {}) => {
  if(!_.isObject(payload)) {
    payload = {type: payload}
  }
  const endPoint = getEndpoint('products.read', payload, `/products/product`, options)
  const {data = {}} = await axios.get(endPoint, {params: omitId(payload)})
  return _.get(data, 'products')
}
setPromise('products.read', read)

export const get = async (id, options = {}) => {
  const payload = _.isObject(id) ? id: {id}
  const endPoint = getEndpoint('products.get', payload, `/products/product/{id}`, options)
  const {data = {}} = await axios.get(endPoint, {params: omitId(payload)})
  return _.get(data, 'data')
}
setPromise('products.get', get)

export const reservationAvailability = async (payload, options = {}) => {
  const endPoint = getEndpoint('products.reservation.availability', {}, '/customer/reservation/availability', options)
  const {data = {}} = await axios.post(endPoint, payload)
  return data
}
setPromise('products.reservation.availability', reservationAvailability)

export const reservationUnavailability = async (payload, options = {}) => {
  const endPoint = getEndpoint('products.reservation.unavailability', {}, '/customer/reservation/unavailability', options)
  const {data = {}} = await axios.post(endPoint, payload)
  return data
}
setPromise('products.reservation.unavailability', reservationUnavailability)

export const reservationHold = async (payload, options = {}) => {
  const endPoint = getEndpoint('products.reservation.hold', {}, '/customer/reservation/hold', options)
  const {data = {}} = await axios.post(endPoint, payload)
  return data
}
setPromise('products.reservation.hold', reservationHold)

const myServices = {read, get, reservationAvailability, reservationUnavailability, reservationHold}

export default {
  ...Main,
  ...myServices
}
